import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'get-form-input-name' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the form input element to get the name attribute from. Must be one of: FormCheckboxInput, FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea, or FormTextInput.'
  ),
});

export const getFormInputNameTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get form input name',
  llmTool: {
    name: toolName,
    description: dedent`
      Retrieve the name attribute of a form input element. Returns the current name
      attribute value as a string, which is used to identify the input when form
      data is submitted to the server. The name attribute is essential for proper
      form processing and data handling. Works with form input types: FormCheckboxInput,
      FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea, and FormTextInput.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: false, // Read-only operation
  timeout: 30000, // 30 seconds for retrieving input name
});
